<template>

    <div
        :class="{
            'grid': mode == 'list',
            'flex flex-col': mode == 'tiled',
        }"
        :style="{
            gridTemplateColumns: mode == 'list' ? `repeat(auto-fill, minmax(${minWidth}, 1fr))` : '',
            gap: gap
        }"
    >
        <slot></slot>
    </div>
</template>

<script>

export default {
    name: 'v-card-list',
    props: {
        mode: {
            type: String,
            default: 'list',
            validator(value) {
                if (['list', 'tiled'].includes(value)) return true;
                return false;
            }
        },
        min: {
            type: [String, Number],
            default: 220
        },
        gap: {
            type: String,
            default: ''
        },
    },
    computed: {
        minWidth() {
            return isNaN(this.min) ? this.min : `${this.min}px`
        }
    },
}

</script>
